module.exports = __webpack_public_path__ + "static/White Logo-9bcff488c3c1a30bd9cb3640d05030ec.png";